import React, { useEffect, useRef, useState } from "react";
import { Tooltip as ToolTipContainer } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css'; // Import Tooltip styles
import abbreviations from "../../Helpers/abbreviations.json";
// import './tooltipComponent.css'; // Import the custom CSS for animation

const Tooltip = ({ id, content, place = "top", children, hideIcon = false, hoverDelay = null }) => {
  const tooltipRef = useRef(null);
  const [placement, setPlacement] = useState(place);
  const isChildComponent = typeof (children) == 'object'


  useEffect(() => {
    const adjustTooltipPosition = () => {
      const tooltipElement = tooltipRef.current;
      if (!tooltipElement) return;

      const tooltipRect = tooltipElement.getBoundingClientRect();
      // Adjust position if tooltip goes out of bounds
      if (tooltipRect.right > window.innerWidth) {
        setPlacement("left");
      } else if (tooltipRect.left < 0) {
        setPlacement("right");
      } else if (tooltipRect.top < 0) {
        setPlacement("bottom");
      } else if (tooltipRect.bottom > window.innerHeight) {
        setPlacement("top");
      }
    };

    window.addEventListener("resize", adjustTooltipPosition);

    return () => window.removeEventListener("resize", adjustTooltipPosition);
  }, []);


  return (
    <div ref={tooltipRef} className="inline relative">
      <span id={hideIcon && id} className=" pr-4">
        {children}
      </span>

      {/* SVG Icon with hover event to control animation */}
      {!hideIcon ? <svg
        id={id}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2.5}
        stroke="currentColor"
        className={`cursor-pointer absolute -top-1 right-0 size-[14px] text-opacity-45 hover:text-opacity-100`}

      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg> : <></>}

      {/* Tooltip component */}
      <ToolTipContainer
        className="text-3xl !p-4 !z-10"
        style={{ maxWidth: "400px", fontSize: "14px", lineHeight: "17px" }}
        anchorId={id} // Anchor the tooltip to the SVG
        place={placement}
        content={isChildComponent ? content : (abbreviations[id] || abbreviations[children?.trim()] || content)} // Tooltip content
        delayShow={hoverDelay}
        delayHide={350}
        variant="info"
      />
    </div>
  );
};

export default Tooltip;
